// Libraries
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { ENTITY_TYPE, TRANSACTION_TYPE } from '../../utils/constants/commonValues';
import {
    Table,
    TableFilter,
    Popup,
    RefundForm,
    FormElems,
    TableSearch,
} from '../../components';
import { fetchRefundRequest } from './redux/refund.actions';
import './refund.scss';
import { useFilteredFields } from 'hooks/customHooks';

let filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment()
                .endOf('day')
                .subtract(1, 'days'),
            endDate: moment().endOf('day'),
            maximumNights: 6,
            notResetDate: true,
        },
    },
    {
        fieldType: 'search-select',
        label: 'Merchant Name',
        name: 'merchantId',
        props: {
            data: [],
            label: 'Select Merchant',
            labelField: 'name',
            valueField: 'entityCode',
        },
    },
];



const setMerchantFilter = (fieldsList, underlyingMerchant) => {
    if (underlyingMerchant.length) {
        fieldsList.forEach(element => {
            if (element.name === 'merchantId') {
                element.props.data = underlyingMerchant;
            }
        });
        return fieldsList;
    }
    return fieldsList.filter(item => item.name !== 'merchantId');
};

const RefundActions = ({ data, fetchData, resetPage }) => {
    const [showFilter, setShowFilter] = useState(false);
    const [actionType, setActionType] = useState(null);
    const handleOpenActionPopup = actionType => {
        setShowFilter(true);
        setActionType(actionType);
    };

    const handleCloseOpenActionPopup = isFetch => {
        setShowFilter(false);
        setActionType(null);
        if (isFetch && !isFetch.target) {
            fetchData({
                pageIndex: 1,
                pageSize: 10,
            });
            resetPage();
        }
    };
    const isRefund =
        data &&
        data.original &&
        data.original.transactionType &&
        data.original.transactionType !== TRANSACTION_TYPE.PAY;
    return (
        <div className="userAction  multiItem">
            <button
                className={`settings ${isRefund ? 'disabled' : ''}`}
                disabled={isRefund}
                onClick={handleOpenActionPopup}
            />
            <Popup
                title={data.original.merchantName}
                actionType={actionType}
                showCloseIcon
                showOverlay
                showFilter={showFilter}
                data={data.original}
                closePopup={handleCloseOpenActionPopup}
            >
                <RefundForm
                    actionType={actionType}
                    data={data.original}
                    handleOpenActionPopup={handleOpenActionPopup}
                    closePopup={handleCloseOpenActionPopup}
                />
            </Popup>
        </div>
    );
};

const Refund = props => {
    const {
        refundData,
        staticData,
        actions,
        loader: { showLoader },
    } = props;

    const { error, tableData, isLoading, pagination } = refundData;

    const { underlyingMerchant } = staticData;
    const [filterData, setFilterData] = useState({ isLive: true });
    const [searchKey, setSearchKey] = useState('ENTITY_TXN_ID');
    const [searchValue, setSearchValue] = useState('');
    const [isTerminalView, setTerminalView] = useState(false)
    useEffect(()=>{
        if(underlyingMerchant?.[0]?.entityType && underlyingMerchant?.[0]?.entityType == ENTITY_TYPE.TERMINAL){
            setTerminalView(true)
        }
    },[underlyingMerchant?.[0]?.entityCode])
    // console.log('for tesint', entityList)
    filterFieldList =  useFilteredFields(
        filterFieldList, 
        isTerminalView, 
        ["merchantId"]
      );
      const getColumns = ()=>{
              const entityType = underlyingMerchant?.[0]?.entityType;
              
                  switch(entityType){
                      case ENTITY_TYPE.TERMINAL:
                          return [
        { header:'Terminal Name',accessor: 'terminalName'},
            { header: 'Terminal TXN ID', accessor: 'orderId' },
            {
                header: 'FCPG TXN ID ',
                accessor: 'transactionReferenceNumber',
            },
            { header: 'Date & Time', accessor: 'transactionDateAndTime' },
            { header: 'Payment mode', accessor: 'paymentMode' },
            { header: 'Amount', accessor: 'transactionAmount' },
            { header: 'Type ', accessor: 'transactionType' },
            { header: 'Refund', accessor: 'action' },
    ]
                  
            default:
                      return[
                        { header: "Merchant Name", accessor: 'merchantName' },
                        { header: 'Merchant TXN ID' , accessor: 'orderId' },
                        {
                            header: 'FCPG TXN ID ',
                            accessor: 'transactionReferenceNumber',
                        },
                        { header: 'Date & Time', accessor: 'transactionDateAndTime' },
                        { header: 'Payment mode', accessor: 'paymentMode' },
                        { header: 'Amount', accessor: 'transactionAmount' },
                        { header: 'Type ', accessor: 'transactionType' },
                        { header: 'Refund', accessor: 'action' },
        ]
                  }
          }
    const columns = useMemo(()=>{return getColumns()}, [underlyingMerchant])
    const getSearchKeyList=()=>{
        const entityType = underlyingMerchant?.[0]?.entityType;
              
                  switch(entityType){
                      case ENTITY_TYPE.TERMINAL:
                            return [
                                {
                                    name: 'FCPG TXN ID',
                                    value: 'TRANSACTION_ID',
                                },
                            ]
                        default:
                            return   [
                                {
                                name: 'Merchant TXN ID',
                                value: 'ENTITY_TXN_ID',
                            },
                                {
                                    name: 'FCPG TXN ID',
                                    value: 'TRANSACTION_ID',
                                },
                            ]
                    }
    }
        const searchKeyList = getSearchKeyList()
    const pageSizeOptions = [10, 20, 40, 60];

    // We'll start our table without any data
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [isResetPage, setIsResetPage] = useState(false);

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = {
                pageSize,
                pageIndex,
            };
            if (
                filterData.createdOn &&
                Object.keys(filterData.createdOn).length
            ) {
                actions.fetchRefundRequest({
                    ...data,
                    ...filterData,
                });
            }
            setPageSize(pageSize);
            setSearchValue('');
        },
        [actions, filterData]
    );

    const liveModeChange = values => {
        setFilterData({ ...filterData, isLive: !filterData.isLive });
    };

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    const filters = setMerchantFilter(filterFieldList, underlyingMerchant);

    const handleSearchSubmit = () => {
        actions.fetchRefundRequest({
            searchKey: searchValue ? searchKey : null,
            searchValue,
        });
    };

    return (
        <div className="refund-wrapper">
            <Table
                tableTitle="Refund"
                filterActionTitle=""
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                data={tableData}
                filterData={filterData}
                error={error && error.errorMessage}
                loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                userActions={data => (
                    <RefundActions
                        data={data}
                        fetchData={fetchData}
                        resetPage={() => setIsResetPage(true)}
                    />
                )}
                tableSearch={
                    <div className="search custom-search-wrapper">
                        <div className="switch">
                            <FormElems.Switch
                                name="isLive"
                                labelField="label"
                                id="test-live"
                                options={[
                                    {
                                        label: 'Live Mode',
                                        value: 'live',
                                    },
                                ]}
                                valueField="value"
                                handleChange={val => liveModeChange(val)}
                                isChecked={filterData.isLive}
                            />
                        </div>
                        <FormElems.Select
                            name="searchKey"
                            placeholder="Select Search Key"
                            id="disbursement-cycle"
                            wrapperClass="settlement-type-field"
                            data={searchKeyList}
                            labelField="name"
                            valueField="value"
                            value={searchKey}
                            handleChange={val => setSearchKey(val)}
                        />
                        <TableSearch
                            search={searchValue}
                            setSearch={setSearchValue}
                            handleSearchSubmit={handleSearchSubmit}
                            placeholder="Enter Search Value"
                        />
                    </div>
                }
                tableFilters={
                    <TableFilter
                        customFilterClass="rightSkewed"
                        showOverlay
                        fieldsList={filters}
                        onSubmit={filterValues => {
                            setFilterData({
                                isLive: filterData.isLive,
                                ...filterValues,
                            });
                            setIsResetPage(true);
                        }}
                        onReset={resetValue => {
                            setFilterData({
                                isLive: filterData.isLive,
                                ...resetValue,
                            });
                            setIsResetPage(true);
                        }}
                    />
                }
            />
        </div>
    );
};

const mapStateToProps = ({ auth, refundData, loader, staticData }) => ({
    auth,
    refundData,
    loader,
    staticData
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchRefundRequest,
        },
        dispatch
    ),
});

Refund.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    refundData: PropTypes.object,
    staticData: PropTypes.object,
    loader: PropTypes.object,
};

RefundActions.propTypes = {
    data: PropTypes.object,
    roleStatus: PropTypes.string,
    fetchData: PropTypes.func,
    resetPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(Refund);
